// --------------------------------------------------------------
// VisitorAIService.js
// FINAL SMART VERSION WITH needs_info + TTS (2025-11-28)
// --------------------------------------------------------------

import axiosClient from "../../api/axiosClient";

const VisitorAIService = {
  async askAI(query, pageContext = {}) {
    try {
      const payload = {
        query,             // 🔥 backend expects `query`
        pageContext        // 🔥 backend expects `pageContext`
      };

      console.log("📤 Sending VisitorAI Payload:", payload);

      const response = await axiosClient.post("/ai/visitor/query", payload);
      const res = response?.data;

      console.log("📥 VisitorAI Response:", res);

      // -----------------------------------------------------
      // NEW — Handle "needs_info"
      // -----------------------------------------------------
      if (res?.status === "needs_info") {
        return {
          status: "needs_info",
          message: res?.message || "More information needed.",
          missing_fields: res?.missing_fields || {},
          normalized_fields: res?.normalized_fields || {},
          llm_suggestion: res?.llm_suggestion || null,
          tts_message: res?.tts_message || null,
          raw: res
        };
      }

      // -----------------------------------------------------
      // SUCCESS NORMALIZATION (existing)
      // -----------------------------------------------------
      if (res?.status === "success") {
        return {
          status: "success",
          reply: res?.data?.summary || res?.data?.message || "AI responded.",
          data: res?.data,
          tts_message: res?.data?.tts_message || null,
          raw: res
        };
      }

      // -----------------------------------------------------
      // Error Normalization
      // -----------------------------------------------------
      return {
        status: "error",
        message: res?.message || "Unknown AI error.",
        raw: res
      };

    } catch (error) {
      console.error("❌ VisitorAI Error:", error);

      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Something went wrong while contacting Visitor AI."
      };
    }
  }
};

export default VisitorAIService;
